
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Requerimiento",
      function () {
        return require("private-next-pages/Requerimiento/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Requerimiento"])
      });
    }
  